import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { isType } from '@/util/type-guards';
import { classNames } from '@/util/utils';
import Error from '../error';
import styles from './spacer.module.css';
interface SpacerProps {
  className?: string;
  value: unknown;
}
export default function Spacer(t0) {
  const $ = _c(10);
  const {
    className,
    value
  } = t0;
  if (isSpacerDef(value)) {
    const t1 = styles[value.value.size];
    let t2;
    if ($[0] !== className || $[1] !== t1) {
      t2 = classNames(className, styles.spacer, t1);
      $[0] = className;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <div className={t2} />;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <summary>Unknown <strong>spacer</strong> attributes:</summary>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== value) {
    t2 = JSON.stringify(value, null, "  ");
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <Error><details>{t1}<pre>{t2}</pre></details></Error>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
interface SpacerDef {
  value: {
    size: 'small' | 'medium' | 'large';
  };
}
function isSpacerDef(data: unknown): data is SpacerDef {
  return isType(data, {
    value: {
      size: ['literal', 'small', 'medium', 'large']
    }
  });
}